import styles from './WhatsOnIcon.module.css';

function WhatsOnIcon() {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            viewBox="0 0 4677.17 1275.59">
            <g>
                <g>
                    <g>
                        <path className={styles.st0} d="M24.16,191.71h253.91l32.97,391.39c4.95,62.21,9.89,128.3,13.19,206.07c0,0,6.59-75.17,1.65,0l23.08-206.07
				l56.06-391.39h176.42l42.87,387.51c9.89,81.65,14.84,128.3,19.79,209.95h1.65c4.95-84.24,8.24-127.01,14.84-208.66l31.33-388.8
				h234.12l-148.39,962.93H538.57l-62.65-531.36h-3.3l-62.65,531.36H170.9L24.16,191.71z"/>
                        <path className={styles.st0} d="M998.57,191.71h242.37v338.26c36.27-38.88,118.71-81.65,183.01-81.65c80.79,0,128.6,20.74,128.6,136.08
				v566.35h-242.37V656.98c0-22.03-6.6-31.1-21.43-31.1c-16.49,0-37.92,9.07-47.81,12.96v511.92H998.57V191.71z"/>
                        <path className={styles.st0} d="M1638.29,969.32c0-147.75,105.52-233.28,308.32-273.46v-42.77c0-44.06-4.95-51.84-28.03-51.84
				c-21.43,0-29.68,10.37-39.57,59.62l-214.34-20.74c39.57-156.82,143.44-191.81,281.94-191.81c161.58,0,230.83,58.32,230.83,196.99
				v336.96c0,82.94,3.3,133.49,13.19,168.48h-232.48c-8.24-18.14-11.54-36.29-11.54-81.65c-29.68,50.54-70.9,86.83-146.74,86.83
				C1712.49,1155.94,1638.29,1109.29,1638.29,969.32z M1946.61,977.09V824.16c-59.36,24.62-75.84,66.1-75.84,117.94
				c0,27.22,11.54,45.36,36.27,45.36C1920.23,987.46,1936.72,982.28,1946.61,977.09z"/>
                        <path className={styles.st0} d="M2319.22,1022.45V603.84h-65.95V457.39h65.95V222.82h240.72v234.58h110.47v146.45h-110.47v347.33
				c0,63.5,16.49,67.39,57.71,67.39c23.08,0,41.22-2.59,52.76-5.18v136.08c-14.84,3.89-65.95,7.78-135.2,7.78
				C2409.91,1157.24,2319.22,1133.91,2319.22,1022.45z"/>
                        <path className={styles.st0} d="M2724.81,938.21l211.04-20.74c11.54,72.58,37.92,99.79,61,99.79c19.79,0,36.27-5.18,36.27-29.81
				c0-42.77-54.41-59.62-117.06-99.79c-80.79-51.84-174.77-120.53-174.77-246.24c0-154.22,150.04-198.29,245.66-198.29
				c159.93,0,255.56,53.14,273.69,211.25l-207.74,25.92c-8.24-72.58-21.43-84.24-52.76-84.24c-14.84,0-28.03,9.07-28.03,27.22
				c0,44.06,49.46,71.28,108.82,107.57c84.09,53.14,186.31,107.57,186.31,230.69c0,120.53-95.63,200.88-265.45,200.88
				C2790.76,1162.42,2742.95,1066.52,2724.81,938.21z"/>
                        <path className={styles.st1} d="M3344.72,671.24c0-357.7,103.87-488.59,319.86-488.59c214.34,0,319.86,130.9,319.86,488.59
				s-105.52,488.59-319.86,488.59C3448.6,1159.83,3344.72,1028.93,3344.72,671.24z M3717.34,671.24
				c0-242.35-1.65-300.67-52.76-300.67c-51.11,0-52.76,58.32-52.76,300.67c0,242.35,1.65,307.15,52.76,307.15
				C3715.7,978.39,3717.34,913.59,3717.34,671.24z"/>
                        <path className={styles.st1} d="M4078.4,457.39h242.37v72.58c36.27-38.88,118.71-81.65,183.01-81.65c80.79,0,128.6,20.74,128.6,136.08
				v566.35h-242.37V656.98c0-22.03-6.6-31.1-21.43-31.1c-16.49,0-37.92,9.07-47.81,12.96v511.92H4078.4V457.39z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path className={styles.st3} d="M2765.75,381.84c-11.85,0-20.28-4.44-25.46-13.27c-5.18-8.83-7.01-19.93-5.52-33.2l42.03-265.52
				c2.96-17.71,8.49-32.07,16.57-43.17c8.09-11.05,21.02-16.57,38.73-16.57h99.56c10.31,0,18.45,3.7,24.32,11.05
				c5.87,7.4,8.83,15.49,8.83,24.32c0,13.27-2.96,26.54-8.83,39.81l-95.17,250.03c-5.92,14.75-12.93,26.2-21.02,34.29
				c-8.14,8.09-20.28,12.19-36.51,12.19h-37.53V381.84z"/>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default WhatsOnIcon;